import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { AlertContext } from '../../../context/AlertProvider';
import StyledAnchor from './styled/Anchor.styled';
import registerNamespace from './locales';
import TextOverflow from '../TextOverflow';

const anchorDefaultPropProps = {};

const namespace = registerNamespace('src/juristec-ui/core/Anchor/Anchor.jsx');

const Anchor = ({ cellContent, props = anchorDefaultPropProps }) => {
  const { t } = useTranslation(namespace);
  const systemMap = {
    'legalone-analytics': 'Legal One Analytics',
    'benner-metrics': 'Benner Metrics',
    legalmetrics: 'Legal Metrics',
  };
  const { setAlertConfig } = useContext(AlertContext);
  const handleAlert = (e) => {
    e.preventDefault();
    setAlertConfig({
      text: t('anchor.externalLinkWarning', { system: systemMap[process.env.REACT_APP_FIREBASE_PROJECT_LABEL] }),
      child: t('anchor.externalLinkChild'),
      type: 'warning',
      confirmFunction: () => {
        window.open(cellContent, '_blank');
      },
      withFunction: true,
      withoutConfirm: true,
    });
  };

  return (
    <StyledAnchor
      onClick={handleAlert}
      href={cellContent}
      target="_blank"
      title={cellContent}
      rel="noopener noreferrer"
      {...props}
    >
      <TextOverflow width={160} fontSize={14}>{cellContent}</TextOverflow>
    </StyledAnchor>
  );
};

Anchor.propTypes = {
  cellContent: PropTypes.string.isRequired,
  props: PropTypes.shape({}),
};

export default Anchor;
